import { getSelectors, ValidationsErrorsCatalogData } from '@repo/core'
import { RootState } from '../../store/types'

export const {
  accountsValidationsErrorsSelector,
  commonValidationsErrorsSelector,
  positionValidationsErrorsSelector,
  toolsValidationsErrorsSelector,
  userValidationsErrorsSelector,
} = (() => {
  return [
    {
      name: 'accountsValidationsErrorsSelector',
      getRootPath: (state: RootState) => state.catalogs.validationsErrors.accounts,
    },
    {
      name: 'commonValidationsErrorsSelector',
      getRootPath: (state: RootState) => state.catalogs.validationsErrors.common,
    },
    {
      name: 'positionValidationsErrorsSelector',
      getRootPath: (state: RootState) => state.catalogs.validationsErrors.position,
    },
    {
      name: 'toolsValidationsErrorsSelector',
      getRootPath: (state: RootState) => state.catalogs.validationsErrors.tools,
    },
    {
      name: 'userValidationsErrorsSelector',
      getRootPath: (state: RootState) => state.catalogs.validationsErrors.user,
    },
  ].reduce(
    (acc, { name, getRootPath }) => ({
      ...acc,
      [name]: getSelectors<ValidationsErrorsCatalogData, RootState>({
        getRootPath,
      }),
    }),
    {} as Record<string, ReturnType<typeof getSelectors<ValidationsErrorsCatalogData, RootState>>>,
  )
})()
